import { createRecipe } from './runtime';

const iconConfig = {"name":"icon","defaultVariants":{"size":"md"},"variantMap":{"size":["2xl","lg","md","sm","xl","xs"]}}

export const icon = /* @__PURE__ */ createRecipe(iconConfig)